import * as React from 'react';

interface Props {
    size?: number;
    color?: string;
}

class DashboardIcon extends React.Component<Props, {}> {

    public static defaultProps: Partial<Props> = {
        size: 16,
    };

    public render(): JSX.Element {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1086 4882 32 26" height={this.props.size} width={this.props.size}>
                <g id="dashboard" transform="translate(-1086 4880)">
                    <path id="Icon_Dashboard" data-name="Icon/Dashboard" fill={this.props.color} d="M32,18.2A16.22,16.22,0,0,0,16,2,16.22,16.22,0,0,0,0,18.2,16.05,16.05,0,0,0,1.8,26h9.8a5.84,5.84,0,0,0,8.8,0h9.8A16.05,16.05,0,0,0,32,18.2ZM28,12v2l-8.2,7a8.662,8.662,0,0,1,.2,1,4,4,0,1,1-4-4,3.768,3.768,0,0,1,1.6.4L26,12ZM20,6h2V8H20ZM10,6h2V8H10ZM4,22H2V20H4Zm2-8H4V12H6Zm24,8H28V20h2Z"/>
                    <path id="Icon_Dashboard" data-name="Icon/Dashboard" fill={this.props.color} d="M11,13a2,2,0,1,1-2-2A2,2,0,0,1,11,13Z" transform="translate(7 9)"/>
                </g>
            </svg>
        );
    }
};



export default DashboardIcon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/DashboardIcon.tsx